/**
 * @fileoverview コンテンツ（記事）の発行者名
 */
<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'PublisherName',

  props: {
    image: {
      type: String,
      default: '',
    },

    label: {
      type: String,
      required: true,
    },
  },
})
</script>

<template>
  <div class="o-label__publisher">
    <p class="o-label__publisher--item">
      <span
        v-if="image"
        class="o-label__publisher--icon">
        <img
          class="img"
          :src="image"
          alt=""
          data-is-liquid="true">
      </span>
      <span class="o-label__publisher--label">
        {{ label }}
      </span>
    </p>
  <!-- /.o-label__publisher --></div>
</template>

<style lang="sass" scoped>
$icon-width: 1.2em  // same size as solution logo in SolutionName.vue (for layout alignment on the history page)
$icon-margin: 0.4em

.o-label__publisher
  & &--item
    display: flex
    align-items: center
    line-height: 1
    font-size: $font-x-small

  & &--icon
    width: $icon-width
    min-width: $icon-width  // for text-overflow in publisher label (To ensure the width of the flex item)
    display: block
    margin-right: $icon-margin

  & &--label
    height: 1em
    display: block
    overflow: hidden
    color: $font-gray
    text-overflow: ellipsis
    white-space: nowrap
</style>
